import {Component, OnInit, ViewChild} from '@angular/core';
import {UserService} from "../user.service";
import {MessageService} from "primeng/api";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {User} from "../../../models/user.model";
import {Observable} from "rxjs";
import {Profil} from "../../../models/profil.model";
import {ProfilService} from "../profil.service";
import { PasswordUpdate } from 'src/app/features/models/password-update.model';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
    @ViewChild('userForm') form!: NgForm;
    @ViewChild('passForm') passform!: NgForm;
    formUser!: FormGroup;
    user!: User;
    passwordUpdated:PasswordUpdate = new PasswordUpdate()
    confirmPass!:string

        genres: { key: string, label: string }[] = [
        {
            key: 'MASCULIN',
            label: 'MASCULIN',
        },
        {
            key: 'FEMININ',
            label: 'FEMININ',
        },
    ];
    typeUtilisateurs: { key: string, label: string }[] = [
        {
            key: 'GERANT',
            label: 'GERANT',
        },
        {
            key: 'SUPERVISEUR',
            label: 'SUPERVISEUR',
        },
        {
            key: 'UTILISATEUR',
            label: 'UTILISATEUR',
        },
    ];
    currentTypeUtilisateur!: { key: string, label: string } | undefined;
    currentGenre!: { key: string, label: string } | undefined;
    profils$!: Observable<Profil[]>;

    constructor(
        private readonly userService: UserService,
        private readonly messageService: MessageService,
        private readonly fb: FormBuilder,
        private readonly dialogRef: DynamicDialogRef,
        private readonly dynamicDialogConfig: DynamicDialogConfig,
        private readonly profilService: ProfilService,
    ) {
    }
    ngOnInit(): void {

        if (this.dynamicDialogConfig.data !== undefined) {
            this.user = this.dynamicDialogConfig.data['user'];
        } else {
            this.user = new User();
        }
        this.profils$ = this.profilService.profils$.asObservable();
        this.createFormGroup();
    }
    
    updatePassword () {
        if (this.confirmPass != this.passwordUpdated.newPassword) {
            this.messageService.add({ severity: 'error', detail: `Les champs Nouveau mot de passe et Confirmation doivent etre conformes!` });
        } else {
            this.userService.updatePassword(this.passwordUpdated).subscribe({
                next: response => {
                    this.messageService.add({ severity: 'success', detail: `Mot de passe mis à jour!` });
                    this.dialogRef.close(response.body);
                },
                error: err => {
                    const message = `Une erreur est survenue lors du changement de mot de passe!`;
                    this.messageService.add({ severity: 'success', detail: message });
                }
            });
        }
    }

    createFormGroup(): void {
        this.formUser = this.fb.group({
            nom: [this.user?.nom, Validators.required],
            prenom: [this.user?.prenom, Validators.required],
            telephone: [this.user?.telephone, Validators.required],
            email: this.user?.email,
        });
    }

    onGetUserInfos() {
        this.user.nom = this.formUser.value.nom;
        this.user.prenom = this.formUser.value.prenom;
        this.user.telephone = this.formUser.value.telephone;
        this.user.email = this.formUser.value.email;

        this.update()
    }

    update(): void {
        this.userService.update(this.user).subscribe({
            next: response => {
                this.messageService.add({ severity: 'success', detail: `Informations mises à jour !` });
                this.dialogRef.close(response.body);
            },
            error: err => {
                const message = `Une erreur est survenue lors de la mise à jour du profil !`;
                this.messageService.add({ severity: 'error', detail: message });
            }
        });
    }

    onCloseModal() {
        this.dialogRef.close(null);
    }
}
